<template>
  <div class="main_right">
    <div class="Box">
      <div class="aRow">
        <!-- 词汇量 -->
        <div class="vocabulary">
          <div>
            <span>我的金币</span>
            <p>
              <span>{{ coinsSum }}</span>
              <span>个</span>
            </p>
          </div>
        </div>
        <!-- 发起兑换按钮 -->
        <div class="exchange" @click="state">
          <span>{{ btnState ? '发起兑换' : '查看明细' }}</span>
        </div>
      </div>
      <div class="testpage" style="height:calc(100% - 3vw);">
        <p>
          <span>{{ btnState ? '金币明细' : '金币兑换' }}</span>
        </p>
        <el-table ref="table" v-if="btnState" class="table" :data="tableData" border
                  :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
          <el-table-column label="日期" align="center" min-width="25%">
            <template slot-scope="scope">
              {{ scope.row.cjrq.slice(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column prop="lymc" label="金币来源" align="center" min-width="50%"/>
          <el-table-column label="获得金币个数" align="center" min-width="25%">
            <template slot-scope="scope">
              {{ scope.row.sl > 0 ? ('+' + scope.row.sl) : scope.row.sl }}
            </template>
          </el-table-column>
        </el-table>
        <el-table ref="table" v-else class="table" :data="thingsTableData" border
                  :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">

          <el-table-column prop="bh" label="商品编号" align="center"/>
          <el-table-column prop="mc" label="商品名称" align="center"/>
          <el-table-column prop="sxjb" label="所需金币(个)" align="center"/>
          <el-table-column prop="sl" label="剩余数量(支)" align="center"/>
          <el-table-column prop="xgsl" label="限购数量(支)" align="center"/>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" round @click="convert(scope.row)">兑 换</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div>
      <div class="pagination" v-if="!btnState">
        <el-pagination background layout="prev, pager, next" :current-page="pages.currentPage"
                       @current-change="handleCurrentChange" :page-size="pages.pageSize" :total="pages.total">
        </el-pagination>
      </div>
    </div>
    <div class="tips" v-if="!btnState">
      <p>如何获得金币</p>
      <p>
        <span>1.每天在单词速记上完成当天学习, 就会收到每天对应的金币奖励</span>
        <span>2.特别注意：每日的奖励和每天背的单词数多少有直接关系</span>
      </p>
    </div>


    <el-dialog :visible.sync="dialogVisible" title="兑换商品" append-to-body width="500px" :before-close="handleClose">
      <div>
        <p style="margin-bottom: 20px;font-size: 16px">将花费 <span
            style="color: red;font-size: 20px">{{ totalCoinsRequired }}</span> 金币兑换 <span
            style="color: red;font-size: 20px">{{ quantity }}</span> 个 <span
            style="color: red;font-size: 20px">{{ selectedItem.mc }}</span></p>
        <p style="margin-bottom: 10px">限购数量: <span style="color: red;">{{ purchase }}</span> 个 </p>
        <el-input-number
            v-model="quantity"
            :min="1"
            :max="purchase"
            label="数量"
            @change="sum"
        ></el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="confirmExchange">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import {getCoinsList, goldSum, selectExchangeItemsPage, saveItemExchange, selectClassByYhid} from "@/api/student";
import {exchangeInquiry,} from '@/api/teacher'

export default {
  data() {
    return {
      tableData: [],
      thingsTableData: [],
      btnState: true,
      coinsSum: 0, // 金币总数
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      bjid: '',
      bjmc: '',
      dialogVisible: false,
      quantity: 1,
      purchase: '',
      selectedItem: {},
      totalCoinsRequired: 0
    }
  },
  created() {
    this.getCoinSum()
    this.getCoinsList()
    this.getThings()
  },
  methods: {
    // 获取金币总量
    getCoinSum() {
      goldSum({xsid: this.$store.state.userInfo.yhid}).then((res) => {
        if (res.success) {
          this.coinsSum = Number(res.result)
        } else {
          this.$message.error(res.resultDesc)
        }
      })
    },
    // 获取金币列表
    getCoinsList() {
      getCoinsList({xsid: this.$store.state.userInfo.yhid}).then((res) => {
        if (res.success) {
          if (res.result.length) {
            // 过滤掉金币数量为零的数据
            // this.tableData = res.result.filter((item) => {
            //   return item.sl != 0;
            // })
            this.tableData = res.result
          } else {
            this.$message.warning("未获得过金币，继续努力");
          }
        } else {
          this.$message.error(res.resultDesc);
        }
      })
    },
    async state() {

      const {result} = await exchangeInquiry({
        bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid
      })
      if (result.sfdh) {
      this.btnState = !this.btnState
      if (!this.bjid) {
        selectClassByYhid({yhid: this.$store.state.userInfo.yhid}).then(res => {
          if (res.success) {
            this.bjid = res.result[0].bjid
            this.bjmc = res.result[0].bjmc
          } else {
            this.$message.error(res.resultDesc)
          }
        })
      }
      } else {
        this.$message.warning('暂未开启兑换')
      }

    },
    // 换页
    handleCurrentChange(val) {
      this.pages.currentPage = val
      this.getThings()
    },
    // 获取商品列表
    getThings() {
      selectExchangeItemsPage({
        currentPage: this.pages.currentPage,
        pageSize: this.pages.pageSize,
        zhid:this.$store.state.userInfo.zhid,
        zt: true
      }).then(res => {
        if (res.success) {
          // this.thingsTableData = res.result.list.filter(item => {
          //   return item.sl
          // })
          this.thingsTableData = res.result.list
          this.pages.total = res.result.total
        } else {
          this.$message.error(res.resultDesc)
        }
      })
    },

    // 兑换
    async convert(data) {
      // if ((this.coinsSum < data.sxjb) && (data.sxjb > 0) ) {
      //   this.$message.warning('您还买不起这个商品~换一种看看吧~')
      //   return false
      // }
      if (data.sl <= 0) {
        this.$message.warning('这个商品已经没货了~换一种看看吧~')
        return false
      }
      this.selectedItem = data;
      this.dialogVisible = true;
      this.totalCoinsRequired = data.sxjb
      this.purchase = data.xgsl
    },
    sum() {
      this.totalCoinsRequired = this.selectedItem.sxjb * this.quantity;
    },
    handleClose() {
      this.quantity = 1
      this.totalCoinsRequired = this.selectedItem.sxjb * this.quantity;
      this.dialogVisible = false
    },
    // 确认兑换
    confirmExchange() {
      if (this.coinsSum < this.totalCoinsRequired) {
        this.$message.warning('您的金币不足以兑换这个商品~');
        return;
      }
      saveItemExchange({
        yycdid: sessionStorage.getItem('yycdid'),
        lsbjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid,
        yycdmc: '单词速记V3.0',
        yylx: 1,
        dhrq: new Date(),
        jbzs: this.coinsSum,
        wpmc: this.selectedItem.mc,
        bjid: Number(this.bjid),
        bjlx: false,
        bjmd: this.bjmc,
        xgr: this.$store.state.userInfo.yhid,
        cjr: this.$store.state.userInfo.yhid,
        sl: this.quantity,
        wpid: this.selectedItem.id,
        xsid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        xsmc: this.$store.state.userInfo.realname
      }).then(res => {
        if (res.success) {
          this.getCoinSum();
          this.getCoinsList();
          this.getThings();
          this.$message.success('兑换成功');
        } else {
          this.$message.error(res.resultDesc);
        }
        this.dialogVisible = false;
      }).catch(() => {
        this.$message.warning('库存整改中');
      });
    }

  }
}
</script>
<style lang="scss" scoped>
.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .Box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;
  }

  .vocabulary {
    width: 30%;
    height: 3vw;
    float: left;

    div {
      width: 14vw;
      height: 3vw;
      background: #f1f8ff;
      border-radius: 10px;
      line-height: 3vw;
      box-sizing: border-box;
      padding: 0 3%;
      color: #333;

      span {
        display: block;
      }

      span:nth-child(1) {
        // display: block;
        font-size: 1.1vw;
        float: left;
      }

      p {
        float: right;

        span:nth-child(1) {
          font-size: 1.5vw;
          color: #409eff;
          font-weight: 600;
          float: left;
          margin-right: 1.5vw;
        }

        span:nth-child(2) {
          font-size: 1vw;
          float: left;
        }
      }
    }
  }

  .pagination {
    position: absolute;
    bottom: 1vw;
    right: 3vw;
    z-index: 1;
  }

  .testpage {
    width: 100%;
    position: relative;

    p:nth-child(1) {
      width: 100%;
      height: 2.5vw;
      text-align: center;
      position: relative;
      color: #333;
      font-size: 1.5vw;
      line-height: 2.5vw;
    }
  }

  .table {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 2vw;
    top: 4vw;
  }

  .aRow {
    width: 100%;
    height: 3vw;
  }

  .aRow:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .exchange {
    width: 7vw;
    float: right;
    height: 2.5vw;
    background: #5990ff;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 30px;
    margin-top: 0.25vw;
    color: #fff;
    font-size: 1vw;
    position: relative;
    cursor: pointer;

    span {
      display: block;
      position: absolute;
      top: 50%;
      width: 100%;
      text-align: center;
      transform: translateY(-50%);
    }
  }

  .tips {
    position: absolute;
    bottom: 1%;
    left: 4%;
    width: 100%;

    p:nth-child(1) {
      font-size: 1vw;
      color: #333;
      width: 100%;
    }

    p:nth-child(2) {
      margin-top: 0.3vw;
      font-size: 0.8vw;
      color: #666;
      width: 100%;

      span:last-child {
        margin-left: 10%;
      }
    }
  }
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;
    height: 100%;
    overflow: hidden;

    .Box {
      padding: 12px 10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      box-sizing: border-box;

      .aRow {
        height: auto;
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        .vocabulary {
          width: auto;
          height: auto;

          div {
            width: auto;
            height: 50px;
            line-height: 50px;
            padding: 0 20px;

            span:nth-child(1) {
              font-size: 14px;
            }

            p {
              span:nth-child(1) {
                font-size: 20px;
                margin-right: 5px;
              }

              span:nth-child(2) {
                font-size: 12px;
              }
            }
          }
        }

        .exchange {
          width: 90px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          margin-top: 0;
          flex-shrink: 0;

          span {
            line-height: 40px;
          }
        }
      }
    }

    .testpage {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;

      p:nth-child(1) {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        flex-shrink: 0;
        text-align: center;
      }

      .table {
        flex: 1;
        overflow: auto;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 2vw;
        top: 9vw;
        ::v-deep  .el-table__body-wrapper {
          overflow-x: auto !important;
          overflow-y: auto !important;
        }

        ::v-deep  .el-table__header {
          width: 100%;
          min-width: 500px;
        }

        ::v-deep  .el-table__body {
          width: 100%;
          min-width: 500px;
        }

        ::v-deep  .el-table__fixed {
          display: none !important;
        }

        ::v-deep  .el-table__fixed-right {
          display: none !important;
        }

        ::v-deep  .el-button--mini {
          padding: 5px 12px;
          font-size: 12px;
        }
      }
    }

    .pagination {
      position: relative;
      bottom: auto;
      right: auto;
      margin-top: 15px;
      display: flex;
      justify-content: flex-end;
      flex-shrink: 0;

      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 8px;
        }

        .el-pager li {
          min-width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }
      }
    }

    .tips {
      position: relative;
      bottom: auto;
      left: auto;
      margin-top: 15px;
      padding: 12px;
      background: #f9f9f9;
      border-radius: 8px;
      flex-shrink: 0;

      p:nth-child(1) {
        font-size: 14px;
        margin-bottom: 8px;
      }

      p:nth-child(2) {
        font-size: 12px;
        line-height: 1.5;

        span {
          display: block;
          margin-left: 0 !important;
          margin-bottom: 5px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .Box {
      padding: 10px 8px;

      .aRow {
        .vocabulary div {
          height: 45px;
          line-height: 45px;
          padding: 0 15px;

          span:nth-child(1) {
            font-size: 12px;
          }

          p span:nth-child(1) {
            font-size: 18px;
          }
        }

        .exchange {
          width: 80px;
          height: 36px;
          line-height: 36px;
          font-size: 12px;

          span {
            line-height: 36px;
          }
        }
      }
    }

    .testpage p:nth-child(1) {
      height: 32px;
      line-height: 32px;
      font-size: 13px;
    }

    .pagination {
      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 6px;
          min-width: 28px;
        }

        .el-pager li {
          min-width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 11px;
        }
      }
    }

    .tips {
      padding: 10px;

      p:nth-child(1) {
        font-size: 12px;
      }

      p:nth-child(2) {
        font-size: 11px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-table::before {
  display: none;
}
@media screen and (max-width: 768px) {
  .el-dialog {
    width: 90% !important;
    max-width: 400px;

    .el-dialog__header {
      padding: 15px 20px 10px;
    }

    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__body {
      padding: 20px;
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
    }
  }
}
</style>
